import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { motion } from 'framer-motion';

export default function Weblayout({ children, isLegal = false, time, stats }) {
  return (
    <div className="home-fixed-viewport d-flex flex-column">
      {/* 1. TOP STATUS TICKER */}
      <div className="d-flex justify-content-between align-items-center mb-3 opacity-75 flex-shrink-0">
        <div className="small d-flex gap-4 align-items-center text-white">
          <span className="text-successnew"><span className="status-dot-pulse me-2"></span> SYSTEM ONLINE</span>
          {stats && (
            <>
              <div className="vr opacity-25" style={{ height: '10px' }}></div>
              <span>{stats.users?.toLocaleString()} Users</span>
              <span>{stats.chats?.toLocaleString()} Messages</span>
            </>
          )}
        </div>
        <div className="small text-white font-monospace">CURRENT TIME: {time || 'SECURE'}</div>
      </div>

      {/* 2. SHARED HEADER */}
      <Header isLegal={isLegal} />

      {/* 3. DYNAMIC CONTENT AREA */}
      <main className="flex-grow-1 min-vh-0 mb-3">
        {children}
      </main>

      {/* 4. SHARED FOOTER */}
      <Footer />
    </div>
  );
}